<script lang="ts" setup>
const props = defineProps<{
  code: number
  message?: string
}>()
const emit = defineEmits(['ok', 'cancel'])
const title = computed(() => {
  if (props.code === 40101) {
    return '下线通知'
  }
  return '权限发生变更'
})
// 40102：被添加
// 40103：被移除
</script>

<template>
  <div class="text-16">
    <div v-if="code === 40101" class="mb-20 indent-26 text-[--color-text-1] font-500 lh-30">
      <img src="~/assets/images/identity/tip.png" class="absolute left-26 top-6 mr-8 w-16">{{ $t('您的账号在另一地点登录，您被迫下线，') }}<br>
      {{ $t('为了账号安全，本次登录已失效，请重新登录') }}
    </div>
    <tamplate v-else>
      <div class="relative mt-16 w-full flex items-center justify-center gap-8 text-center font-500">
        <img src="~/assets/images/user/vip/tip.png" class="w-16">
        {{ $t(title) }}
        <span class="absolute right--8 top--8 h-20 w-20 flex cursor-pointer items-center justify-center text-18 text-[--color-text-1] hover:op-80" @click="emit('cancel')"><i class="icon-shanchu" /></span>
      </div>
      <div class="mb-16 mt-24 text-center text-14 text-[--color-text-2]">
        {{ code === 40102 ? $t('vip.linkedTeam', [message]) : $t('vip.removedTeam', [message]) }}
      </div>
    </tamplate>
    <div class="ml--24 mr--24 mt-16 box-border flex justify-center gap-8 px-24 pb-24" :class="{ '!justify-end py-16 b-t-1 b-t-[#F2F3F5] b-t-solid': code === 40101 }">
      <a-button class="h-28 px-10 text-14" type="primary" @click="emit('ok')">
        {{ code === 40102 ? $t('重新登录享最新权益') : $t('重新登录') }}
      </a-button>
    </div>
  </div>
</template>
